import React from 'react';
import {
	styled,
	ParentBoundComponent
} from 'ps-gui';

import { withGlobalContext } from '../../data/globalcontext';
import LoginModel from './loginmodel';

import LoginForm from './components/loginform';
import LoginAuthCode from './components/loginauthcodeform';
import PasswordChangeAuthCode from './components/passwordchangeresult';
import ForgottenPasswordForm from './components/forgottenpasswordform';
import BankIdButton from '../../components/bankidbutton';
import { getPhrase } from '../../data/phrases';
import EmailAddress from '../../components/emailaddress';
import PhoneNumber from '../../components/phonenumber';

class LoginModule extends ParentBoundComponent {
	constructor() {
		super();
		this.login = this.login.bind(this);
		this.setProperty = this.setProperty.bind(this);
		this.otpLogin = this.otpLogin.bind(this);
		this.reset = this.reset.bind(this);
		this.showForgottenPasswordForm = this.showForgottenPasswordForm.bind(this);
		this.createPasswordChangeAuthenticationCode = this.createPasswordChangeAuthenticationCode.bind(this);
	}

	async createPasswordChangeAuthenticationCode() {
		this.setModel(await this.getModel().createPasswordChangeAuthenticationCode(this.props.globalContext.getLanguageId()));
	}

	showForgottenPasswordForm() {
		this.setModel(this.getModel().showForgottenPasswordForm());
	}

	reset() {
		this.setModel(new LoginModel());
	}

	async otpLogin() {
		this.setModel(await this.getModel().otpLogin());
	}

	async login() {
		this.setModel(await this.getModel().login(this.props.globalContext.getLanguageId()));
	}

	getModel() {
		return new LoginModel(this.getData());
	}

	setModel(model) {
		this.setData(model ? model.getData() : null);
	}

	render() {
		const model = this.getModel();

		if(model.isLoginAuthCode()) {
			return (
				<Wrapper>
					<LoginAuthCode
						data={model.getData()}
						phoneNumber={model.getPhone()}
						setProperty={this.setProperty}
						otpLogin={this.otpLogin}
						reset={this.reset} />
				</Wrapper>
			);
		}

		if(model.isPasswordChangeAuthCode()) {
			return (
				<Wrapper>
					<PasswordChangeAuthCode
						passwordChangeAuthCode={model.getPasswordChangeAuthCode()}
						createPasswordChangeAuthenticationCode={this.createPasswordChangeAuthenticationCode} />
				</Wrapper>
			);
		}

		if(model.isForgottenPasswordForm()) {
			return (
				<Wrapper>
					<ForgottenPasswordForm
						data={model.getData()}
						createPasswordChangeAuthenticationCode={this.createPasswordChangeAuthenticationCode}
						setProperty={this.setProperty}
						reset={this.reset} />
				</Wrapper>
			);
		}

		return (
			<Wrapper>
				<LoginForm
					data={this.getData()}
					bankIdMatcherInfo={model.getBankIdMatcherInfo()}
					setProperty={this.setProperty}
					login={this.login}
					showForgottenPasswordForm={this.showForgottenPasswordForm}
				/>
				<BankIdButton margin="64px 32px 0px 0px"/>
				<FormFooter>
					{getPhrase('troubleSigningIn')}
					<Div marginTop="16px">
						<EmailAddress preset="intergram" margin="2px 24px 2px 0px"/>
						<PhoneNumber preset="intergram" withHours />
					</Div>
				</FormFooter>
			</Wrapper>
		);
	}
}

const Wrapper = styled.div`
	${props => props.theme.pageContentPadding}

	.ps-form {
		width: 370px;
		.ps-formItem {
			margin-bottom: 24px;
		}
	}

	.footer {
		border-top: 1px solid ${props => props.theme.pageSeparatorColor};
		padding-top: 24px;
		margin-top: 24px;

		.text {
			color: ${props => props.theme.disabledTextColor};
			font-weight: 400;
			font-size: 16px;
			margin-right: 24px;
		}
	}
`;

const FormFooter = styled.div`
	width: 370px;
	margin-top: 40px;
	padding-top: 24px;
	border-top: 1px solid ${props => props.theme.pageSeparatorColor};
`;

const Div = styled.div`
	margin-top: ${props => props.marginTop};
	> a {
		vertical-align: top;
		&.emailAddress {
			top: -2px;
		}
	}
`;


export default withGlobalContext(LoginModule);
